// Bambody v2 — interactive components for the new landing page:
//   - Flow indicator (Light/Moderate/Heavy/Overnight → swaps description)
//   - Sizing table (row click → updates sticky "Your fit" panel)
// Both self-init on DOMContentLoaded, scoped by section wrapper.

(function () {
  function wireFlowIndicator(section) {
    if (section.dataset.bamV2FlowReady) return
    section.dataset.bamV2FlowReady = '1'
    const btns = section.querySelectorAll('[data-flow-btn]')
    const nameEl = section.querySelector('[data-flow-name]')
    const descEl = section.querySelector('[data-flow-desc]')
    const capEl = section.querySelector('[data-flow-cap]')
    const dropIcons = section.querySelectorAll('[data-flow-drop]')
    if (!btns.length) return

    btns.forEach((btn) => {
      btn.addEventListener('click', () => {
        const idx = Number(btn.dataset.flowBtn)
        btns.forEach((b) => b.classList.toggle('is-active', Number(b.dataset.flowBtn) === idx))
        if (nameEl) nameEl.textContent = btn.dataset.name
        if (descEl) descEl.textContent = btn.dataset.desc
        if (capEl) capEl.textContent = btn.dataset.cap
        dropIcons.forEach((d) => {
          const on = Number(d.dataset.flowDrop) <= idx
          d.setAttribute('fill', on ? '#9F8BED' : '#E7DEF3')
        })
      })
    })
  }

  function wireSizingTable(section) {
    if (section.dataset.bamV2SizingReady) return
    section.dataset.bamV2SizingReady = '1'
    const rows = section.querySelectorAll('[data-size-row]')
    const sizeEl = section.querySelector('[data-size-current]')
    const waistEl = section.querySelector('[data-size-waist]')
    const hipEl = section.querySelector('[data-size-hip]')
    const recEl = section.querySelector('[data-size-rec]')
    const cta = section.querySelector('[data-size-cta]')
    if (!rows.length) return

    rows.forEach((row) => {
      row.addEventListener('click', () => {
        rows.forEach((r) => r.classList.toggle('is-active', r === row))
        const size = row.dataset.size
        if (sizeEl) sizeEl.textContent = size
        if (waistEl) waistEl.textContent = row.dataset.waist
        if (hipEl) hipEl.textContent = row.dataset.hip
        if (recEl) recEl.textContent = `Your everyday fit in size ${size} — the most-loved fit for this range.`
        if (cta) cta.textContent = `Shop size ${size}`
      })
    })
  }

  function wireReviewsCarousel(section) {
    if (section.dataset.bamV2ReviewsReady) return
    section.dataset.bamV2ReviewsReady = '1'
    const track = section.querySelector('[data-v2-reviews-track]')
    const prev = section.querySelector('[data-v2-reviews-prev]')
    const next = section.querySelector('[data-v2-reviews-next]')
    if (!track) return

    const step = () => {
      const card = track.querySelector('.bam-v2-reviews__card')
      const gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 22
      return card ? card.getBoundingClientRect().width + gap : 340
    }
    const updateArrows = () => {
      if (prev) prev.disabled = track.scrollLeft <= 4
      if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4
    }
    prev?.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }))
    next?.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }))
    track.addEventListener('scroll', () => requestAnimationFrame(updateArrows), { passive: true })
    updateArrows()
  }

  function init(root = document) {
    root.querySelectorAll('[data-bam-v2-how]').forEach(wireFlowIndicator)
    root.querySelectorAll('[data-bam-v2-sizing]').forEach(wireSizingTable)
    root.querySelectorAll('[data-v2-reviews]').forEach(wireReviewsCarousel)
  }

  document.addEventListener('DOMContentLoaded', () => init())
  document.addEventListener('shopify:section:load', (e) => init(e.target))
})()
